// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3YLew","bigColWidth":"Table_bigColWidth__3_8I8","biggerColWidth":"Table_biggerColWidth__24_cU","row":"Table_row__IkqLe","col":"Table_col__f0VTc"};